import { createSelector } from 'reselect';

const getPaymentError = (state) => state?.paymentError;

export const paymentErrorSelector = createSelector(
  [getPaymentError],
  (paymentError) => paymentError,
);
